import { Box, TextField, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'

interface PageIndicatorProps {
  pageInputValue: string
  handleInputPageChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  maxPage: number
  hidePageSign: boolean
  size: number
}

const PageIndicator = observer(
  ({
    pageInputValue,
    handleInputPageChange,
    maxPage,
    hidePageSign,
    size,
  }: PageIndicatorProps) => {
    if (hidePageSign) return null

    return (
      <Box sx={indicatorWrapperSx}>
        <Typography variant='body2' sx={{ whiteSpace: 'nowrap' }}>
          Страница
        </Typography>
        <PageInput
          value={pageInputValue}
          onChange={handleInputPageChange}
          size={size}
        />
        <Typography variant='body2' sx={{ whiteSpace: 'nowrap' }}>
          из {maxPage ?? 0}
        </Typography>
      </Box>
    )
  }
)

const PageInput = ({
  value,
  onChange,
  size,
}: {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  size: number
}) => (
  <TextField
    value={value}
    onChange={onChange}
    variant='standard'
    sx={getTextFieldSx(size)}
    inputProps={{ sx: { textAlign: 'center' } }}
    autoComplete='off'
  />
)

const getTextFieldSx = (size: number) => ({
  '& .MuiInputBase-root': {
    width: getInputWidth(size),
    height: 16,
    mx: 1,
    fontSize: '0.875rem',
    fontWeight: 500,
  },
})

const getInputWidth = (size: number) => {
  if (size > 999) return '42px'
  if (size > 99) return '32px'
  if (size > 9) return '21px'
  return '15px'
}

const indicatorWrapperSx = {
  display: 'flex',
  alignItems: 'center',
  marginRight: '24px',
  paddingBottom: '3px',
}

export default PageIndicator
